import * as React from 'react';
import { InverseBg } from './types';

export const InverseBgContext = React.createContext<InverseBg>({});
